import React from 'react'
import LoadingIcons from 'react-loading-icons'

const SubmitButton = ({name,onSubmit, width,disabled,loading}) => {
  return (
    <button onClick={(e) => {!loading && onSubmit && onSubmit(e)}} 
        disabled={disabled || loading}
        style={{width:width + 'px' || '100%'}}
        className={`flex h-8 rounded-lg items-center justify-center shrink-0 font-light ${disabled || loading?'bg-[rgba(0,175,240,.8)]':'bg-[rgb(0,175,240)]'} text-white hover:bg-[rgba(0,175,240,.8)] shadow-md overflow-hidden`}>
        {loading?<LoadingIcons.Oval width={24} height={24}/>
        :
        <p className='w-full overflow-hidden overflow-ellipsis'>{name?name:'Submit'}</p>}
    </button>
  )
}

export default SubmitButton